import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import get from 'lodash/get';
import noop from 'lodash/noop';
import { Map } from 'immutable';
import HtmlStripsService from '@Services/HtmlStripsService';

import { commaFormatNumber } from '@Utils/String';

import { Checkbox } from '@els/els-react--checkbox';

Checkbox.propTypes.label = PropTypes.oneOfType([PropTypes.string, PropTypes.node]);

export default function BarChartFilterGroupItem(props) {
  const { group, disabled, onChange, customFilterConfig } = props;
  const title = HtmlStripsService.getTitleWithoutHtml(group.get('title'), 'stripexceptions');
  const size = group.get('size');
  const selected = group.get('selected');
  const affiliation = group.get('affiliation');

  const optionTitle = get(customFilterConfig, 'optionTitle', noop)(title);
  const optionIcon = get(customFilterConfig, 'optionIcon', noop)(title);
  const titleContent = optionTitle || title;

  let content;

  if (optionIcon) {
    content = (
      <div className="bar-chart-filter-group-item__label">
        <svg className="els-btn-icon rx-border-none els-btn-icon-sm bar-chart-filter-group-item-icon">
          <use xlinkHref={optionIcon} />
        </svg>
        <span className="bar-chart-filter-group-item-icon-title">{titleContent}</span>
      </div>
    );
  } else if (affiliation) {
    content = (
      <div className="bar-chart-filter-group-item__label bar-chart-filter-group-item__label--multiline">
        <span className="bar-chart-filter-group-item__title">{titleContent}</span>
        <span className="bar-chart-filter-group-item__affiliation">{affiliation}</span>
      </div>
    );
  } else {
    content = titleContent;
  }

  return (
    <li className="bar-chart-filter-group-item">
      <Checkbox
        disabled={disabled}
        className="bar-chart-filter-group-item-checkbox-wrapper"
        checked={selected}
        onChange={onChange}
        label={content}
        title={`Select ${titleContent} filter`}
      />
      <span
        className={classnames('bar-chart-filter-items-count', {
          'bar-chart-filter-items-count--disabled': disabled,
        })}>
        {size && commaFormatNumber(size)}
      </span>
    </li>
  );
}

BarChartFilterGroupItem.propTypes = {
  group: PropTypes.instanceOf(Map).isRequired,
  onChange: PropTypes.func.isRequired,
  disabled: PropTypes.bool.isRequired,
  customFilterConfig: PropTypes.object,
};
